<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="eSF / eAP"
            description="Indicadores para eSF ou eAP na APS"
            url="/indicadores-aps"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/p/h/8cj1fp4-2631/2fc51123cde0aa5/8cj1fp4-3591"
            :enableBadgeModalInformacao="
              Number($store.state.permissoesRaw?.esf_eap_ajuda || 0) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.esf_eap_ajuda || 0
            "
            keyAjudaModalInformacao="esf_eap_ajuda"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img v-else-if="item.imagem !== ''" :src="item.imagem" alt="" />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import MaisAcessoAps from '@/components/icons/IndicadoresAps/eSFeAP/MaisAcessoAps.vue'
import PessoaIdosa from '@/components/icons/IndicadoresAps/eSFeAP/PessoaIdosa.vue'
import SaudeDaMulher from '@/components/icons/IndicadoresAps/eSFeAP/SaudeDaMulher.vue'
import PessoaHipertensao from '@/components/icons/IndicadoresAps/eSFeAP/PessoaHipertensao.vue'
import PessoaDiabetes from '@/components/icons/IndicadoresAps/eSFeAP/PessoaDiabetes.vue'
import DesenvolvimentoInfantil from '@/components/icons/IndicadoresAps/eSFeAP/DesenvolvimentoInfantil.vue'
import GestantesPuerperas from '@/components/icons/IndicadoresAps/eSFeAP/GestantesPuerperas.vue'

export default {
  name: 'eSFeAP',
  metaInfo: {
    title: 'eSF / eAP',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    MaisAcessoAps,
    PessoaIdosa,
    SaudeDaMulher,
    PessoaHipertensao,
    PessoaDiabetes,
    DesenvolvimentoInfantil,
    GestantesPuerperas,
  },
  computed: {
    cards() {
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.esf_eap
      ) {
        const dataClone = [...this.$store.state.permissoes.esf_eap]
        return dataClone.sort((a, b) => a.ordem - b.ordem)
      }
      return []
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
